import {capitalizeFirst} from '@wandb/weave/core/util/string';

import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {TooltipNumberOfRunsOptions} from '../../WorkspaceDrawer/Settings/types';
import {mappedBooleanDisplayValue} from '../utils';
import {
  createBooleanDisplayFn,
  createEnumDisplayFn,
} from './linePlotDisplayFactories';

const tooltipNumberOfRunsLabels: Record<TooltipNumberOfRunsOptions, string> = {
  [TooltipNumberOfRunsOptions.Single]: 'Single run',
  [TooltipNumberOfRunsOptions.Default]: 'Default',
  [TooltipNumberOfRunsOptions.All]: 'All runs',
};

export const getColorRunNamesDisplayRow = createBooleanDisplayFn({
  field: 'colorRunNames',
  label: 'Color run names',
  groupTitle: 'Display preferences',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.colorRunNames,
  formatter: mappedBooleanDisplayValue,
});

export const getCoordinateZoomingDisplayRow = createBooleanDisplayFn({
  field: 'coordinateZooming',
  label: 'Sync zoom across charts',
  groupTitle: 'Display preferences',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.coordinateZooming,
  formatter: mappedBooleanDisplayValue,
});

export const getDisplayFullRunNameDisplayRow = createBooleanDisplayFn({
  field: 'displayFullRunName',
  label: 'Display full run name',
  groupTitle: 'Display preferences',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.displayFullRunName,
  formatter: mappedBooleanDisplayValue,
});

export const getHighlightedCompanionRunOnlyDisplayRow = createBooleanDisplayFn({
  field: 'highlightedCompanionRunOnly',
  label: 'Show highlighted run only',
  groupTitle: 'Display preferences',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.highlightedCompanionRunOnly,
  formatter: mappedBooleanDisplayValue,
});

export const getShowLegendDisplayRow = createBooleanDisplayFn({
  field: 'showLegend',
  label: 'Show legend',
  groupTitle: 'Display preferences',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.showLegend,
  formatter: (value: boolean) => mappedBooleanDisplayValue(value),
});

export const getShowXRangeDisplayRow = createBooleanDisplayFn({
  field: 'showXRange',
  label: 'Show X range in tooltip',
  groupTitle: 'Display preferences',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.showXRange,
  formatter: mappedBooleanDisplayValue,
});

export const getTooltipNumberOfRunsDisplayRow = createEnumDisplayFn({
  field: 'tooltipNumberOfRuns',
  label: 'Tooltip runs',
  groupTitle: 'Display preferences',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.tooltipNumberOfRuns,
  formatter: value =>
    tooltipNumberOfRunsLabels[value] ?? capitalizeFirst(value),
});
